import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player/lazy';

const VideoPlayer = ({ video_url, thumbnail_url, ...props }) => {
  const [url, setUrl] = useState();

  useEffect(() => {
    if (video_url) {
      if (video_url.constructor.name === 'File') {
        setUrl(URL.createObjectURL(video_url));
        return () => URL.revokeObjectURL(video_url);
      } else {
        setUrl(video_url);
      }
    }
  }, [video_url]);

  return (
    <ReactPlayer
      controls
      playing
      width="100%"
      height="100%"
      className="embed-responsive embed-responsive-16by9"
      url={url}
      config={{
        file: {
          attributes: {
            poster: thumbnail_url,
          },
        },
      }}
      {...props}
    />
  );
};

export default VideoPlayer;
